export default __webpack_public_path__ + "static/media/Wave.5b5303b1.png";